var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "attachment--container px-0 ml-2 mt-0 pt-2" },
    [
      !_vm.coCategoriesLoader
        ? _c("h1", { staticClass: "attachment--container__title ml-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.documentType.name) +
                " (" +
                _vm._s(_vm.documentType.totalDocuments) +
                ")\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("document-attachments")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b88b8fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b88b8fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/documents/document-attachment-list/template.html
// module id = null
// module chunks = 